import React from "react"
import "./Range.scss"
import Input from "../Input/Input";
import PropTypes from "prop-types"

export class Range extends Input {

  inputType="range"

  format = () => {
    switch (this.props.format) {
      case "ratio" :
        return this.value() 
        break;
      case "percentage" :
        return this.value() 
        break;
      default :
      return this.value() 
        break;
    }
  }
}

Range.propTypes = {
  ...Input.propTypes,
  inputProps: PropTypes.shape({
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired
  })
}

// Range.defaultProps = {
//   //...BaseField.defaultProps,
//   inputProps: {
//     step: 1
//   }
// }

export default Range
